

























































































    import WaitIndicator from "../Common/WaitIndicator.vue";
    import PositionActionMenu from './PositionActionMenu.vue'
    import PositionDetails from './PositionDetails.vue'
    import Component from 'vue-class-component'
    import {Prop, Watch, Vue, Emit} from 'vue-property-decorator'
    import Scrollable from "../Common/Scrollable.vue";
    import {extractJsonDate, formatPrice} from "../../utils/formatters";
    import {AssetType} from '../../domain/types'
    import TradingBlockRemote from '../../services/TradingBlockRemote';
    import TableScroller from '../Common/TableScrollable.vue'
    import {Position} from "../../domain/Position";
    
    @Component({
        components: {Scrollable, WaitIndicator, PositionActionMenu,TableScroller, PositionDetails}
    })

    class PositionTable extends Vue{
        @Prop()
        loading: boolean;
        @Prop()
        loaded: boolean;
        @Prop()
        rows: any;
        @Prop()
        ErrorMessage:string = "";
        @Prop()
        Summary:any;
        scrollOffset: number = 0;
        msg_closed: boolean =false;
        get scrollLeft() {
            return this.scrollOffset;
        }
        set scrollLeft(v) {
            this.scrollOffset = v;
            $("#TbPositionTable .table-responsive").scrollLeft(v);
        }

        columns:any = ['DateOpened','Symbol','Description', 'UnderlyingPrice',
            // 'CostBasis',
            'BasisPerShare','Ask', 'Bid'
            //'OpenQuantity',
            //'CurrentValue','UnrealizedGain'
            // , 'Actions'
            ] as any;
        options:any={
            uniqueKey:"N",
            sortable: ['DateOpened','Symbol', 'Description'],
//                    dateColumns:['Date'],
//                    dateFormat: 'YYYY-MM-DD',
            columnsDropdown:true,
            headings: {
                DateOpened: 'Date Opened',
                // CostBasis: 'Cost Basis',
                // OpenQuantity: 'Open Quantity',
                // CurrentValue:'Current Value',
                // UnrealizedGain:'Unrealized Gain',
                UnderlyingPrice:'Underlying Price',
                BasisPerShare:'Basis Per Share'
            },
        }as any;

        scrollWidth:number = 0;
        mounted() {
            if (this.loaded){


                Vue.nextTick(()=> {

                });
            }
            var self = this;
            this.onResize();
           (window as any).onresize =()=>this.onResize();

        }
        scrollContWidth: number = 0;

        onResize (){
            if (this.scrollContWidth != $('#TbPositionTable .VueTables__table').outerWidth()) {
                this.scrollContWidth = $("#TbPositionTable .VueTables__table").parent().width();
                this.scrollWidth = $("#TbPositionTable .VueTables__table").width();
            }
            return false;
        }

        @Watch('loaded')
            scrollUpdate(v:boolean){
            if (!v) return;
            Vue.nextTick(()=> {
                this.scrollOffset = $("#TbPositionTable .table-responsive").scrollLeft();
                this.scrollWidth = $("#TbPositionTable .VueTables__table").width();
            });
        }

        updated() {
            if (this.loaded)
                Vue.nextTick(()=>{
                this.scrollWidth = $("#TbPositionTable .VueTables__table").width()
                    $("#TbPositionTable .table-responsive").scroll(()=>
                        this.scrollLeft =  $("#TbPositionTable .table-responsive").scrollLeft())
                    }

                );
        }

//        mounted(){
//
//            Vue.nextTick(()=>{
//                if (this.$el.offsetWidth < this.$el.scrollWidth){
//                    if (this.$el.scrollX>0) this.showLeftArrow = true;
//                    else this.showLeftArrow = false;
//                    if (this.$el.scrollY + this.$el.offsetWidth >=this.$el.scrollWidth)
//                        this.showRightArrow = true;
//                    else
//                        this.showRightArrow = false;
//                }
//
//            });
//        }
//        updated(){
//            Vue.nextTick(()=>{
//
//            });
//        }
//        columns: any[] =  [
//                {
//                    label: 'Date Opened',
//                    field: 'DateOpened',
//                    type: 'string'
//                    // inputFormat: 'YYYYMMDD',
//                    // outputFormat: 'MMM Do YY',
//                },
//                {
//                    label: 'Symbol',
//                    field: 'Symbol',
//                    filterable: true,
//                },
//                {
//                    label: 'Description',
//                    field: 'Description',
//                    filterable: true,
//                },
//                {
//                    label: 'Bid Price',
//                    field: 'BidPrice',
//                    type: 'number'
//                },
//                {
//                    label: 'Ask Price',
//                    field: 'AskPrice',
//                    type: 'number'
//                },
//                {
//                    label: 'Cost Basis',
//                    field: 'CostBasis',
//                    type: 'number'
//                },
//                {
//                    label: 'Open Quantity',
//                    field: 'OpenQuantity',
//
//                },
//                {
//                    label: 'Current Value',
//                    field: 'CurrentValue'
//                },
//                {
//                    label: 'Unrealized Gain',
//                    field: 'UnrealizedGain'
//                },
//                {
//                    label: 'Net Change',
//                    field: 'NetChange'
//                },
//                {
//                    label: 'Actions',
//                    field: 'OrderId'
//                }
//
//    ] as any[];



    }

    export default PositionTable;
